import { useId, useState } from 'react'
import ProjectAgentAssignmentRow from '@/frontend/features/Fde/ProjectAgentAssignmentRow'
import type { Agent, FdeCopy, ProjectAgent } from '@/frontend/features/Fde/types'

export interface ProjectAgentInput {
  [key: string]: string | boolean
  digital_worker_id: string
  role_name: string
  specialist_kind: ProjectAgent['specialist_kind']
  primary: boolean
}
interface Props {
  agents: Agent[]
  assignments: ProjectAgentInput[]
  savedAssignments: ProjectAgent[]
  copy: FdeCopy
  variant?: 'form' | 'page'
  onChange: (assignments: ProjectAgentInput[]) => void
}

export default function ProjectAgentAssignments({ agents, assignments, savedAssignments, copy, variant = 'form', onChange }: Props) {
  const instanceId = useId()
  const [editingId, setEditingId] = useState<string | null>(null)
  function toggleAgent(agent: Agent, checked: boolean) {
    if (checked) {
      onChange([...assignments, { digital_worker_id: agent.id, role_name: agent.job_title || agent.name, specialist_kind: agent.default_project_specialist_kind || 'fde_resident', primary: assignments.length === 0 }])
      setEditingId(agent.id)
      return
    }
    const remaining = assignments.filter((item) => item.digital_worker_id !== agent.id)
    if (remaining[0] && !remaining.some((item) => item.primary)) remaining[0] = { ...remaining[0], primary: true }
    onChange(remaining)
    if (editingId === agent.id) setEditingId(null)
  }
  function update(agentId: string, changes: Partial<Pick<ProjectAgentInput, 'role_name' | 'specialist_kind'>>) {
    onChange(assignments.map((item) => item.digital_worker_id === agentId ? { ...item, ...changes } : item))
  }
  return <fieldset aria-label={copy.forms.project_agents} className="min-w-0">
    {variant === 'form' && <legend className="mb-2 text-sm font-medium">{copy.forms.project_agents}</legend>}
    <div className={`divide-y divide-border ${variant === 'form' ? 'max-h-80 overflow-y-auto rounded-lg border border-border px-3' : 'border-y border-border'}`}>
      {!agents.length && <p className="py-6 text-sm text-muted-foreground">{copy.forms.no_agents}</p>}
      {agents.map((agent) => <ProjectAgentAssignmentRow key={agent.id} agent={agent} assignment={assignments.find((item) => item.digital_worker_id === agent.id)} saved={savedAssignments.find((item) => item.agent.id === agent.id)} editing={editingId === agent.id} instanceId={instanceId} copy={copy}
        onEdit={() => setEditingId(editingId === agent.id ? null : agent.id)} onToggle={(checked) => toggleAgent(agent, checked)} onUpdate={(changes) => update(agent.id, changes)}
        onPrimary={() => onChange(assignments.map((item) => ({ ...item, primary: item.digital_worker_id === agent.id })))} />)}
    </div>
  </fieldset>
}
